export default "__VITE_ASSET__DbE5ZQw0__"